module.exports = __webpack_public_path__ + "img/be-assigned@3x.f6855598.png";